import { render, staticRenderFns } from "./ExtendOtherNutrientsCalcium.vue?vue&type=template&id=5b33992b&scoped=true"
import script from "./ExtendOtherNutrientsCalcium.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsCalcium.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsCalcium.vue?vue&type=style&index=0&id=5b33992b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b33992b",
  null
  
)

export default component.exports